import { useContext } from "react";
import { RootStoreContext, RootStoreType } from "../stores";

export const useMobXStore = (): RootStoreType => useContext(RootStoreContext);
